var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from './Contacts.module.scss';
import RemoveFromContacts from '../../assets/person-dash.svg';
import ChangeContactIcon from '../../assets/change.svg';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { clearSelectedMessage, closeMenu, setIsFavorites, setTempChat } from "../../store/slices/appSlice";
import { contactsAPI, messagesAPI } from "../../API/api";
import InputComponent from "../../InputComponent/InputComponent";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import Preloader from '../../assets/preloader.svg';
import pLimit from 'p-limit';
import DialogComponent from "../Settings/DialogComponent";
import AddContactForm from "../forms/AddContactForm";
const test = [
    { displayName: 'alexdb', photoURL: '', email: 'test1rt@test.com', uid: 'uhrtugjfghdhc' },
    { displayName: 'alexcbc55555555555555', photoURL: '', email: 'test1fg@test.com', uid: 'uhugjfgfghdhc' },
    { displayName: 'alexvbcx', photoURL: '', email: 'test1cv@test.com', uid: 'uhugjfgcvhdhc' },
    { displayName: 'alexfgdh', photoURL: '', email: 'test1nb@test.com', uid: 'uhugjfgbnhdhc' },
    { displayName: 'alexzzzzc', photoURL: '', email: 'test1sd@test.com', uid: 'usdhugjfghdhc' },
    { displayName: 'alexds', photoURL: '', email: 'test1io@test.com', uid: 'uhugjfghiodhc' },
    { displayName: 'alexvxv', photoURL: '', email: 'test1ti@test.com', uid: 'uhugjfghdtihc' },
    { displayName: 'alexbbbb', photoURL: '', email: 'test1hh@test.com', uid: 'uhugjfghdhhhc' },
    { displayName: 'alexcvxv', photoURL: '', email: 'test1ddg@test.com', uid: 'uhudgdgjfghdhc' },
    { displayName: 'alexxv', photoURL: '', email: 'test1jr@test.com', uid: 'uhugjfghdgdhjdhc' },
    { displayName: 'alexzzzzs', photoURL: '', email: 'test1rw@test.com', uid: 'uhugjwqqfghdhc' },
    { displayName: 'alexvvcvbbb', photoURL: '', email: 'test1dhhj@test.com', uid: 'uhugjddghfghdhc' },
    { displayName: 'alexdgsd', photoURL: '', email: 'test1qqq@test.com', uid: 'uhuqqqgjfghdhc' },
    { displayName: 'alexbbb', photoURL: '', email: 'test1fhfr@test.com', uid: 'uhugjfgjfghdhc' },
    { displayName: 'test1', photoURL: '', email: 'test1dete@test.com', uid: 'uhuhjhggjfghdhc' },
];
const CONCURRENCY_LIMIT = 3;
const limit = pLimit(CONCURRENCY_LIMIT);
const Contacts = () => {
    const [name, setName] = useState('');
    const [sending, setSending] = useState(false);
    const [isOpenDialog, setIsOpenDialog] = useState({ isOpen: false, contact: null });
    const dispatch = useAppDispatch();
    const contactsList = useAppSelector(state => state.app.contacts);
    const isSend = useAppSelector(state => state.app.isSendMessage);
    const selectedMessageList = useAppSelector(state => state.app.selectedMessages);
    const selectedChat = useAppSelector(state => state.app.selectedChat);
    const currentUser = useAppSelector(state => state.app.currentUser);
    const { t } = useTypedTranslation();
    const removeFromContacts = (e, contact) => {
        e.stopPropagation();
        contactsAPI.removeFromContacts(currentUser.email, contact);
        console.log('удалён из контактов');
    };
    const handleClickName = (user) => {
        if (isSend) {
            setSending(true);
            const limitedPromises = selectedMessageList.map(item => limit(() => messagesAPI.forwardedMessageFrom(currentUser, user, item)));
            Promise.all(limitedPromises)
                .then(() => setSending(false))
                .finally(() => {
                dispatch(closeMenu());
                dispatch(clearSelectedMessage());
            });
            return;
        }
        if ((selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.uid) === user.uid) {
            dispatch(closeMenu());
            return;
        }
        dispatch(setTempChat(user));
        dispatch(closeMenu());
    };
    const sendToFavorites = () => {
        if (!isSend) {
            dispatch(setIsFavorites(true));
            dispatch(closeMenu());
            return;
        }
        const limitedPromises = selectedMessageList.map(item => limit(() => messagesAPI.addToFavorites(currentUser, item)));
        setSending(true);
        Promise.all(limitedPromises)
            .then(() => setSending(false))
            .finally(() => {
            dispatch(closeMenu());
            dispatch(clearSelectedMessage());
        });
    };
    const changeContact = (contact) => __awaiter(void 0, void 0, void 0, function* () {
        contactsAPI.changeContact({ myEmail: currentUser.email, contact })
            .then(() => setIsOpenDialog({ isOpen: false, contact: null }))
            .catch(err => console.log('error change contact', err));
    });
    const changeDialogState = (action, contact = null) => {
        setIsOpenDialog({
            contact,
            isOpen: action
        });
    };
    const filter = contactsList.filter(item => {
        var _a;
        const search = name.toLowerCase();
        return (item.displayName.toLowerCase().includes(search) ||
            ((_a = item.nameWasGiven) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search)));
    });
    return (_jsxs("div", { className: styles.container, children: [sending && _jsx("div", { className: styles.container__preloader, children: _jsx(Preloader, { fontSize: '2rem' }) }), _jsx("div", { className: styles.item, children: _jsx("span", { children: t('contacts') }) }), _jsx(InputComponent, { classes: styles.item, returnValue: setName }), _jsx("div", { className: styles.item, children: _jsxs("ul", { className: styles.list, children: [_jsx("li", { onClick: sendToFavorites, children: _jsx("span", { children: t('favorites') }) }), filter.map((item) => (_jsxs("li", { onClick: () => handleClickName(item), children: [_jsx("span", { children: (item === null || item === void 0 ? void 0 : item.nameWasGiven) || item.displayName }), _jsxs("div", { className: styles.buttonBlock, children: [!isSend &&
                                            _jsx("div", { title: t('change'), onClick: (e) => {
                                                    e.stopPropagation();
                                                    changeDialogState(true, item);
                                                }, children: _jsx(ChangeContactIcon, {}) }), !isSend && _jsx("div", { title: t('removeFromContacts'), onClick: (e) => removeFromContacts(e, item), children: _jsx(RemoveFromContacts, {}) })] })] }, String(item.uid))))] }) }), _jsx(DialogComponent, { onClose: changeDialogState, isOpen: isOpenDialog.isOpen, children: _jsx(AddContactForm, { functionPerformed: changeContact, user: isOpenDialog.contact, change: true }) })] }));
};
export default Contacts;
